import Sidebar from '../../components/Common/Sidebar';
import FraudEngineFramework from '../../components/_pages/FraudEngine/FraudEngine';

const FraudEngine = () => {
  return (
    <>
      <Sidebar />
      <FraudEngineFramework/>
    </>
  );
};

export default FraudEngine;
